import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useSearchParams } from 'react-router-dom'
import { Box } from '@mui/material'

import { BI_ROUTES } from '@constants'
import { resetCommonFilters } from '@signals'
import { BISelectedOffice, BISelectedOfficeOptions, clearBISignals, setFormData } from './@signals'
import PageWrapper from 'Pages/@PageWrapper'
import BIFilters from './Filters'
import BIPageContent from './Content'
import BIPageWrapperActions from 'Pages/BusinessLogistics/BI/Page/Actions'
import VirtualTourButton, { TourOverlay, TOUR_STEPS } from './VirtualTour'
import BIDemoData from './VirtualTour/DemoData'


export default function BIPage() {
	const [tourActive, setTourActive] = useState(false)
	const [searchParams] = useSearchParams()

	useEffect(() => {
		resetCommonFilters()
		clearBISignals()
		BISelectedOfficeOptions.value = []
		BISelectedOffice.value = null

		const sp = searchParams.get('sp')
		if (sp) {
			try {
				const bytes = new Uint8Array([...atob(sp)].map(c => c.charCodeAt(0)))
				const decoded = JSON.parse(new TextDecoder().decode(bytes))
				setFormData({ ...decoded, urlId: searchParams.get('urlId') })
			} catch {}
		}

		return () => {
			resetCommonFilters()
			clearBISignals()
			BISelectedOfficeOptions.value = []
			BISelectedOffice.value = null
		}
	}, [])

	return <PageWrapper
		head={`DS Rentacar | ${BI_ROUTES.TITLE}`}
		title={BI_ROUTES.TITLE}
		subtitle={BI_ROUTES.SUBTITLE}
		isEmpty={false}
		filters={<BIFilters/>}
		actions={<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
			<BIPageWrapperActions/>
			<VirtualTourButton onClick={() => setTourActive(true)} />
		</Box>}
	>
		<BIPageContent/>
		{tourActive && <BIDemoData />}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => setTourActive(false)} />,
			document.body
		)}
	</PageWrapper>
}
